export default {
      id: "i-features-03-usage",
      viewBox: "0 0 21 25",
      url: __webpack_public_path__ + "img/sprite.svg#i-features-03",
      toString: function () {
        return this.url;
      }
    }